import { render, staticRenderFns } from "./RefundProducsDetails.vue?vue&type=template&id=33ce1be9&"
import script from "./RefundProducsDetails.vue?vue&type=script&lang=js&"
export * from "./RefundProducsDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports